module.exports = __webpack_public_path__ + "img/bpp.ae03a62f.png";